export default "__VITE_ASSET__aMqAdtQr__"